<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm" class="flex flex-col">
  <div>
    <div class="m-b-20">
      You can archive the selected consultant. Archived consultant are still available to view in the Expert Services,
      but will be hidden by default.
    </div>
    <!--    <div class="m-b-20">-->
    <!--      <strong>Note: </strong> You may want to update/close any associated DAC6 Forms and Tasks for the Cases being archived.-->
    <!--    </div>-->

    <div class="m-b-20">
      <strong>Are you sure you want to archive the selected consultant?</strong>
    </div>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Add Comment (Optional)</mat-label>
      <textarea matInput formControlName="comment" type="text" [(ngModel)]="data.input['comment']"
                placeholder="Add Comment (Optional)" rows="5">
             </textarea>
    </mat-form-field>
  </div>
</form>
